export default "__VITE_ASSET__r7E16s84__"